import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import AnalyticsChart from "../analytics/index";
import CustomersCard from "../../components/dashboard/customersCard";
import WidgetCompanyDeadlines from "../deadlines/widgetCompany";
import WidgetCreditsAndRevenues from "../widget/widgetCreditsAndRevenues";
import WidgetOperations from "../widget/widgetOperations";
import WidgetTools from "../widget/widgetTools";
import WidgetTSPay from "../widget/widgetTsPay";
import WidgetCheckupImpresa from "../widget/WidgetCheckupImpresa";
import WidgetSummaryCheckupImpresa from "../widget/WidgetSummaryCheckupImpresa";

import { getUsersList } from "../../store/actions/company/index";
import { getCheckupSummary } from "../../store/actions/rating/index";

import { FEATURE_TOGGLE_ANALYTICS, FEATURE_TOGGLE_TSPAY } from "../../config";

import "../dashboard/style.css";
import "./style.css";

const SchedaCliente = () => {

  const navigate = useNavigate();
  const currentPermissions = useSelector(state => state.currentPermissions);
  const analytics = useSelector(state => state.analytics);
  const auth = useSelector(state => state.auth);
  const studio = useSelector((state) => state.studio);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const usersList = useSelector(state => state.usersList);
  const services = useSelector(state => state.servicesAgyo);
  const [valueRandom, setValueRandom] = useState(0.5);

  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const myType = main.myType;

  let studioFind;

  if (main?.accountantUuidSelected) {
    studioFind = studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
    company?.companies?.find(x => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find(x => x?.uuid === main?.accountantUuidSelected);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersList(true));
  }, []);

  useEffect(() => {
    setValueRandom(Math.random());
  }, []);

  useEffect(() => {
    dispatch(getCheckupSummary());
  }, []);

  const goToOtherDeadlinesSubjective = () => {
    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:SC-SCADENZE-CLIENTE");
    }    
    navigate({
      pathname: "/scadenzecliente",
      state: {
        viewType: "calendar"
      }
    });   
  };

  const goToOtherStatistics = () => {
    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:SC-BUSINESS-PERFORMANCE");
    }
    navigate("/statistiche");
  };

  const renderFooter = () => {
    return (
      <div style={{ textAlign: "right" }}>
        <Button
          kind={"secondary"}
          colorScheme={"ghost"}
          onClick={e => goToOtherStatistics()}
        >
          <FormattedMessage id="customerPage.analyticsChart.showAllBusinesssPerformance" />
        </Button>
      </div>
    );
  };

  const renderCheckupWidget = (
    index, title, accountantHasCheckupImpresa
  ) => {
    return (
      <div><WidgetSummaryCheckupImpresa
        index={index}
        title={title}
        accountantHasCheckupImpresa={accountantHasCheckupImpresa}
      />
      </div>);
  };

  const renderCustomer = () => {
    let arrayDatiAzienda = company.companies.find(el => {
      return el.codiceFiscale === companySelected;
    });
    const address =
      arrayDatiAzienda.indirizzo +
      ", " +
      arrayDatiAzienda.citta +
      " (" +
      arrayDatiAzienda.provincia +
      ") " +
      arrayDatiAzienda.cap +
      " - " +
      arrayDatiAzienda.nazione;
    const customer = {
      identifier: {
        taxId: arrayDatiAzienda.codiceFiscale,
        vatNumber: arrayDatiAzienda.partitaIva
      },
      details: {
        description: arrayDatiAzienda.ragioneSociale,
        addresses: address
      }
    };

    return (
      accountantIdSelected &&
      companySelected && (
        <CustomersCard
          element={customer}          
          accountantIdSelected={accountantIdSelected}
          companySelected={companySelected}
          isCustomer={true}
          isAvailableToUser={false}
          isCompany={classifierCompanySelected === "COMPANY"}
          hasAddress={arrayDatiAzienda.indirizzo}
          fromSchedaCliente={true}
          isCustomersListView={false}
        />
      )
    );
  };

  let allAccountantServices = {};
  let accountantHasTSPay = false;
  let accountantHasCheckupImpresa = false;

  if (
    !services?.allAccountantServices.status.started &&
    services?.allAccountantServices.status.ended &&
    services?.allAccountantServices?.status?.list
  ) {
    allAccountantServices = services?.allAccountantServices.status.list;
  }
  for (let service in allAccountantServices){
    if (allAccountantServices[service] && (allAccountantServices[service].id === "TSPAY" || allAccountantServices[service].id === "BANKLINK-INFO" || allAccountantServices[service].id === "BANKLINK-POST")){
      accountantHasTSPay = true;
    }
    if (allAccountantServices[service] && (allAccountantServices[service].id === "MODE-CRAM")){
      accountantHasCheckupImpresa = true;
    }
  }
  const objCompanySelected = company.companies
    ? company.companies.find(el => {
      return el.codiceFiscale === companySelected;
    })
    : null;
  const classifierCompanySelected = objCompanySelected
    ? objCompanySelected.classifier
    : null;

  return (
    <div className="dashboardWrapper">
      <div  style={{
        display: "flex",
        flexDirection: "row",
        width: "100%"
      }}>
        <div style={{width: "calc(33% - 10px)", marginRight: "10px", marginBottom: "10px"}}>{renderCheckupWidget(
          1, "Rating creditizio", accountantHasCheckupImpresa
        )}</div>
        <div style={{width: "calc(33% - 10px)", marginRight: "10px", marginBottom: "10px"}}>{renderCheckupWidget(
          2, "DSCR", accountantHasCheckupImpresa
        )}</div>
        <div style={{width: "calc(33% - 10px)", marginRight: "10px", marginBottom: "10px"}}>{renderCheckupWidget(
          3, <FormattedMessage id="checkup.sectorIndices" />, accountantHasCheckupImpresa
        )}</div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: "1 0 0",
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "0 0 calc(33% - 10px)",
            width: "calc(33% - 10px)",
            marginRight: "10px"
          }}
        >
          {renderCustomer()}

          {classifierCompanySelected !== "PERSON" ? <WidgetTools /> : null}

          {FEATURE_TOGGLE_ANALYTICS === "true" &&
          classifierCompanySelected !== "PERSON" ? (
              <WidgetCreditsAndRevenues
                auth={auth}
                accountantIdSelected={accountantIdSelected}
                analytics={analytics}
                currentPermissions={currentPermissions}
                user={user}
                usersList={usersList}
              />
            ) : null}
          { FEATURE_TOGGLE_TSPAY === "true" && studioFind?.taxRegion !== "ES" ?
            !accountantHasCheckupImpresa && !accountantHasTSPay ?
              ( valueRandom < 0.5 ? <WidgetCheckupImpresa/> : <WidgetTSPay /> )
              :
              !accountantHasTSPay && accountantHasCheckupImpresa ?
                (<WidgetTSPay />)
                :
                !accountantHasCheckupImpresa && accountantHasTSPay ?
                  (<WidgetCheckupImpresa/>)
                  : null
            : null}

        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "0 0 calc(66% - 10px)",
            width: "calc(66% - 10px)"
          }}
        >
          {FEATURE_TOGGLE_ANALYTICS === "true" &&
          classifierCompanySelected !== "PERSON" ? (
              <AnalyticsChart
                classChart=""
                idDivForChart="analyticsView-chart"
                footer={renderFooter()}
                kpiType={9}
              />
            ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between"
            }}
          >
            {classifierCompanySelected !== "PERSON" && (
              <div className="divider left">
                <WidgetOperations />
              </div>
            )}

            {/* Renderizzo il widget se e solo se ho il set di prop minime a far scattare
             * il componenteDidMount diversamente ci possono essere problemi di chiamate non
             * fatte o chiamate doppie
             */
              /** TODO FIX DASH */
              studioFind?.taxRegion !== "ES" && auth && companySelected && accountantSelected ? (
                <div
                  className={
                    classifierCompanySelected !== "PERSON" ? "divider" : "person"
                  }
                >
                  <WidgetCompanyDeadlines
                    classNameProp={"cardSkeleton boxFluid cardSkeletonGraph"}
                    goToOtherDeadlinesSubjective={goToOtherDeadlinesSubjective}                    
                    isDoubleBox={false}
                    numberItems={4}
                    myType={myType}
                  />
                </div>
              ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedaCliente;
